import { push as routerPush } from 'redux-first-history';

import { logoutFetchingAction, logoutSuccessAction } from 'users/reducers/auth';

import { LOGIN_PATH } from '../selectors/sidebar/common';
import { SessionFeatures } from '../constants/ui';
import logoutService from '../services/logoutService/logoutService';

import { fetchConfig } from './config';
import { resetStoresAction } from './common';

// eslint-disable-next-line import/prefer-default-export
export const logout = () => (dispatch) => {
  dispatch(logoutFetchingAction());

  logoutService().then(() => {
    dispatch(logoutSuccessAction());
    dispatch(resetStoresAction());
    dispatch(fetchConfig());
    dispatch(routerPush(LOGIN_PATH));

    Object.keys(sessionStorage).forEach((key) => {
      if (key.includes(SessionFeatures.HideNewsAlert)) {
        sessionStorage.removeItem(key);
      }
    });
  });
};
